import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ContributoUnificatoFormComponent
} from 'src/app/common/form/sez-economica/contributo-unificato-form.component';
import { ContributoUnificato } from 'src/app/common/models/contributo-unificato';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { ContributoUnificatoAdapter } from '../sezione-economica-contributo-unificato-add/contributo-unificato-adapter';

@Component({
  selector: 'div [contributo-unificato-form-edit]',
  templateUrl: '../../../form/sez-economica/contributo-unificato-form.component.html',
})

export class ContributoUnificatoEditComponent extends ContributoUnificatoFormComponent {
  private petitumRevisione: PetitumRevisione;
  private contributoUnificato: ContributoUnificato;
  private urlInsert: string;
  private sezione: SezioneEconomica;
  private fascicolo: FascicoloFull;
  @Input() edit: boolean;
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  ngOnInit() {
    this.setTitle('Modifica Contributo unificato');
    this.isInserimento(false);
  }

  getEdit() {
    return this.edit;
  }

  getContributoUnificato() {
    return this.contributoUnificato ? this.contributoUnificato : new ContributoUnificato();
  }

  getRequest(contributoUnificatoRequest: ContributoUnificato) {
    let idSezione: string = PropertiesSettings.NEW_SEZIONE;
    if (this.sezione && this.sezione.id) {
      idSezione = this.sezione.id;
    }
    // debugger;
    this.operationService.updateContributoUnificato(this.urlInsert, contributoUnificatoRequest, idSezione, this.fascicolo.id).
      subscribe((response: any) => this.datiResponse(response));
  }

  datiResponse(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, fascicolo: FascicoloFull, urlInsert: string, recuperoCrediti: boolean) {
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.urlInsert = urlInsert;
    this.contributoUnificato = new ContributoUnificatoAdapter(sezione.contributoUnificato).contributoUnificato;
    //this.petitumRevisione = petitumRevisione;
    this.recuperoCrediti = recuperoCrediti;
    this.createForm();
    this.populateSelect();
  }

}
